import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setBenefitPrices = payload =>
  call(websocketFetch, 'set_benefit_prices', {
    ...payload,
  });
